module.exports = __webpack_public_path__ + "static/welcome-to-djawn-banner-2213ac5cd2c6df078c9089ebfe7f17fe.png";